import { char, number } from "../../utils";
import { selector } from "../../api";
import moment from "moment";

export const ERMSReport = (props) => {
  const { data, dataRef, tableRef, title } = props;

  const user = selector.User();

  return (
    <>
      <div className="row" hidden>
        <div className="col-12" ref={dataRef}>
          <div className="printHead">
            <p className="text-center">
              <img
                width={100}
                className="mt-0 mb-2"
                src="assets/images/suza.jpeg"
                alt=""
              />
            </p>
            <p className="text-center fw-bold head1">
              {char.toTitleCase("state university of Zanzibar")}
            </p>
            <p className="text-center mt-3 mb-3 head2">
              {char.toUpperCase("erms " + title + " list")}
            </p>
            <p className="text-end">
              Printed By :{" "}
              <span className="fw-bold">{char.toUpperCase(user.username)}</span>
            </p>
            <p className="text-end mb-2">
              Printed at :{" "}
              <span className="fw-bold">
                {moment().format("ddd DD MMM YYYY")}
              </span>
            </p>
          </div>
          <div className="table-responsive" ref={tableRef}>
            <table className="table table-bordered table-sm">
              <thead className="table-head">
                <tr>
                  <th style={{ width: 50 }}>#</th>
                  <th>Ref No.</th>
                  <th>Payer Name</th>
                  <th>Control No.</th>
                  <th>Currency</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((dt, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>
                      {dt.request
                        ? char.toUpperCase(dt.request.data.client.code)
                        : "N/A"}
                    </td>
                    <td>
                      {dt.request
                        ? char.toUpperCase(dt.request.data.client.name)
                        : "N/A"}
                    </td>
                    <td>
                      {dt.request ? dt.request.data.controlNumber : "N/A"}
                    </td>
                    <td>
                      {dt.request
                        ? char.toUpperCase(dt.request.data.currencyCode)
                        : "N/A"}
                    </td>
                    <td className="text-end">
                      {dt.request ? number.fNumberDoublePoint(
                        dt.request.data.amount
                      ) : "0.00"}
                    </td>
                  </tr>
                ))}
                {!data?.length && (
                  <tr>
                    <td colSpan={8} className="text-center">
                      {char.toLowerCase("no data to print")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
